/* eslint-disable */

// This file was automatically generated by @icp-sdk/bindgen@0.4.1.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import type { ActorMethod } from '@icp-sdk/core/agent';
import type { Principal } from '@icp-sdk/core/principal';
import { IDL } from '@icp-sdk/core/candid';

export interface Account {
  'owner' : Principal,
  'subaccount' : [] | [Uint8Array],
}
export interface BaseToken {
  'fee' : bigint,
  'decimals' : number,
  /**
   * How ICPSwap names this ledger's standard: "ICP" or "ICRC2".
   */
  'icpswap_standard' : string,
  'ledger' : Principal,
  'symbol' : string,
}
export interface BuyArgs {
  /**
   * Who sent this buyer (an app, a bot, a link). They earn 0.2% of the trade, from Soon's half of
   * the fee. Optional.
   */
  'referrer' : [] | [Principal],
  /**
   * Where the tokens (and any refund) go, if not the caller: a bot or app buying for someone.
   */
  'recipient' : [] | [Account],
  'from_subaccount' : [] | [Uint8Array],
  /**
   * Base to spend, trading fee included. The ledger fee for the pull is charged on top.
   */
  'amount' : bigint,
  'min_tokens_out' : bigint,
}
export interface Candle {
  't' : bigint,
  'low' : number,
  'high' : number,
  'close' : number,
  'open' : number,
  'volume' : bigint,
}
export interface Challenge {
  'height' : bigint,
  'reward' : bigint,
  /**
   * Mining stops when the market has emitted MINE_SUPPLY.
   */
  'open' : boolean,
  'prev_hash' : Uint8Array,
  'target' : bigint,
  'market' : Principal,
}
export interface Comment {
  'at' : bigint,
  'id' : bigint,
  'who' : Principal,
  'text' : string,
}
export type CurveError = { 'TooSmall' : null } |
  { 'ZeroAmount' : null } |
  {
    /**
     * Selling more than the curve ever sold would push real reserves below zero.
     */
    'ExceedsSold' : { 'sold' : bigint }
  } |
  { 'Slippage' : { 'out' : bigint, 'min_out' : bigint } } |
  { 'CurveComplete' : null };
export interface Fill {
  /**
   * For a buy: tokens out. For a sell: base out to the user (after the trading fee).
   */
  'out' : bigint,
  /**
   * Base actually consumed (buy) or produced (sell), before the fee.
   */
  'base_net' : bigint,
  /**
   * The order bought the last token on the curve.
   */
  'completes' : boolean,
  'fee_platform' : bigint,
  'fee_creator' : bigint,
  /**
   * Base handed back because the curve filled up mid-order.
   */
  'refund' : bigint,
}
export type GradStep = {
    'Release' : { 'pool' : Principal, 'positions' : Array<bigint> }
  } |
  { 'Mint' : { 'pool' : Principal } } |
  { 'Deposit' : { 'pool' : Principal } } |
  { 'MintLp' : { 'pool' : Principal } } |
  { 'RequestPool' : null };
export interface GraduationTicket {
  'token_amount' : bigint,
  'base' : BaseToken,
  'ledger' : Principal,
  /**
   * Fair listing amounts: the base raised and the LP token allocation.
   */
  'base_amount' : bigint,
}
export interface HttpRequest {
  'url' : string,
  'method' : string,
  'body' : Uint8Array,
  'headers' : Array<[string, string]>,
}
export interface HttpResponse {
  'body' : Uint8Array,
  'headers' : Array<[string, string]>,
  'status_code' : number,
}
export interface IcpSwapIds {
  'passcode_manager' : Principal,
  'factory' : Principal,
  'calculator' : Principal,
}
export interface MarketInfo {
  'x' : bigint,
  'y' : bigint,
  'id' : Principal,
  'x0' : bigint,
  'height' : bigint,
  'mine_supply' : bigint,
  'mined' : bigint,
  'cycles_balance' : bigint,
  'reward' : bigint,
  'outbox' : bigint,
  'creator' : Principal,
  'creator_owed' : bigint,
  'platform_owed' : bigint,
  'lp_fees_token' : bigint,
  'expected_hashes' : number,
  'base' : BaseToken,
  'trades' : bigint,
  'meta' : TokenMeta,
  'sold' : bigint,
  'created_at' : bigint,
  'lp_fees_base' : bigint,
  'target' : bigint,
  'traders' : bigint,
  'cycles_burned_rigs' : bigint,
  /**
   * Referral shares not paid yet, all referrers together (held with the curve's reserve).
   * Optional, so apps reading markets of different versions decode both.
   */
  'referral_owed' : [] | [bigint],
  'cycles_burned_market' : bigint,
  'ledger' : Principal,
  /**
   * Every referral share ever booked.
   */
  'fees_referrers' : [] | [bigint],
  'raised' : bigint,
  'progress_bps' : number,
  'gross_to_complete' : bigint,
  'token_fee' : bigint,
  'last_block_at' : bigint,
  'phase' : Phase,
  'active_rigs' : number,
  'price' : number,
  'curve_supply' : bigint,
  'volume_base' : bigint,
  'treasury' : Principal,
}
export interface MarketInit {
  /**
   * Virtual base reserve, fixed at launch from the USD target.
   */
  'x0' : bigint,
  'creator' : Principal,
  'base' : BaseToken,
  'meta' : TokenMeta,
  'icpswap' : IcpSwapIds,
  'ledger' : Principal,
  'factory' : Principal,
  /**
   * The creator's first buy, in base units (trading fee included). The factory sends these funds
   * to the market before installing it, and the market makes the buy inside `init`, so it is the
   * curve's first trade: nobody can buy before it. Optional so markets made before it still load.
   */
  'dev_buy' : [] | [bigint],
  /**
   * The blackhole canister, which answers `canister_status` for canisters it controls.
   */
  'status_proxy' : [] | [Principal],
  'treasury' : Principal,
}
export interface MinerStat {
  /**
   * Those still mining here now (seen in the last two minutes). Optional so a reader built for this
   * version still reads a market that hasn't been upgraded yet.
   */
  'active' : [] | [number],
  'owner' : Principal,
  /**
   * Every rig of this owner that has ever mined here.
   */
  'rigs' : number,
  'locked' : bigint,
  'burned' : bigint,
}
export type PayoutStatus = { 'Queued' : { 'id' : bigint } } |
  { 'Sent' : { 'block' : bigint } };
export type Phase = {
    'Graduating' : { 'last_error' : [] | [string], 'step' : GradStep }
  } |
  { 'Graduated' : { 'pool' : Principal, 'positions' : Array<bigint> } } |
  { 'Trading' : null };
export interface Referral {
  /**
   * Not paid yet (it goes out with the six-hourly fees, or with claim_referral_fees).
   */
  'owed' : bigint,
  /**
   * Everything this referrer has earned on this token.
   */
  'earned' : bigint,
}
export type Result = { 'Ok' : TradeOk } |
  { 'Err' : TradeError };
export type Result_1 = { 'Ok' : Challenge } |
  { 'Err' : string };
export type Result_2 = { 'Ok' : PayoutStatus } |
  { 'Err' : string };
export type Result_3 = { 'Ok' : bigint } |
  { 'Err' : string };
export type Result_4 = { 'Ok' : Fill } |
  { 'Err' : CurveError };
export interface SellArgs {
  /**
   * Who sent this seller. They earn 0.2% of the trade, from Soon's half of the fee. Optional.
   */
  'referrer' : [] | [Principal],
  /**
   * Where the base (and, if the sell fails, the tokens) go, if not the caller: a bot or app
   * selling for someone.
   */
  'recipient' : [] | [Account],
  'from_subaccount' : [] | [Uint8Array],
  'min_base_out' : bigint,
  'amount' : bigint,
}
export type SubmitResult = {
    'Won' : { 'height' : bigint, 'reward' : bigint }
  } |
  { 'NotARig' : null } |
  { 'Invalid' : null } |
  { 'Stale' : { 'height' : bigint } } |
  { 'Closed' : null };
export interface TokenMeta {
  'x' : [] | [string],
  /**
   * `data:image/...;base64,...`, at most 48 KiB.
   */
  'logo' : string,
  'name' : string,
  'description' : string,
  'website' : [] | [string],
  'telegram' : [] | [string],
  'symbol' : string,
}
export interface Trade {
  'at' : bigint,
  'id' : bigint,
  'buy' : boolean,
  'who' : Principal,
  'base' : bigint,
  'tokens' : bigint,
  /**
   * Price after the trade, in base per whole token (display only).
   */
  'price' : number,
}
export type TradeError = {
    /**
     * The price moved before your funds arrived. They are being returned.
     */
    'Refunded' : { 'reason' : CurveError, 'refund' : [] | [PayoutStatus] }
  } |
  { 'Rejected' : string } |
  { 'Transfer' : string } |
  { 'Curve' : CurveError };
export interface TradeOk {
  'fill' : Fill,
  'payout' : PayoutStatus,
  'refund' : [] | [PayoutStatus],
}
export interface _SERVICE {
  'buy' : ActorMethod<[BuyArgs], Result>,
  'candles' : ActorMethod<[boolean, bigint], Array<Candle>>,
  /**
   * Called by rigs. `burned` is the rig's own cycle burn since its last call (display only: nothing
   * about consensus depends on it).
   */
  'challenge' : ActorMethod<[bigint], Result_1>,
  /**
   * Anyone may trigger this. The money can only go to the creator.
   */
  'claim_creator_fees' : ActorMethod<[], Result_2>,
  /**
   * Anyone may trigger this. The money can only go to the treasury fixed at launch (via the factory on
   * ICP-priced tokens, which keeps what the platform needs in cycles and forwards the rest).
   */
  'claim_platform_fees' : ActorMethod<[], Result_2>,
  /**
   * Anyone may trigger this. The money can only go to the referrer it's owed to.
   */
  'claim_referral_fees' : ActorMethod<[Principal], Result_2>,
  'comments' : ActorMethod<[number], Array<Comment>>,
  /**
   * The factory asks for this before creating the ICPSwap pool.
   */
  'graduation_ticket' : ActorMethod<[], [] | [GraduationTicket]>,
  'http_request' : ActorMethod<[HttpRequest], HttpResponse>,
  'info' : ActorMethod<[], MarketInfo>,
  /**
   * Mined rewards held until graduation. Released automatically once the token lists.
   */
  'locked_of' : ActorMethod<[Principal], bigint>,
  'miners' : ActorMethod<[], Array<MinerStat>>,
  'mining_info' : ActorMethod<[], Challenge>,
  'post_comment' : ActorMethod<[string], Result_3>,
  'quote_buy' : ActorMethod<[bigint], Result_4>,
  'quote_sell' : ActorMethod<[bigint], Result_4>,
  /**
   * What a referrer has earned on this token, in base.
   */
  'referral_of' : ActorMethod<[Principal], Referral>,
  'sell' : ActorMethod<[SellArgs], Result>,
  'submit' : ActorMethod<[bigint], SubmitResult>,
  'trades' : ActorMethod<[number], Array<Trade>>,
}
export const BaseToken = IDL.Record({
  'fee' : IDL.Nat,
  'decimals' : IDL.Nat8,
  'icpswap_standard' : IDL.Text,
  'ledger' : IDL.Principal,
  'symbol' : IDL.Text,
});
export const TokenMeta = IDL.Record({
  'x' : IDL.Opt(IDL.Text),
  'logo' : IDL.Text,
  'name' : IDL.Text,
  'description' : IDL.Text,
  'website' : IDL.Opt(IDL.Text),
  'telegram' : IDL.Opt(IDL.Text),
  'symbol' : IDL.Text,
});
export const IcpSwapIds = IDL.Record({
  'passcode_manager' : IDL.Principal,
  'factory' : IDL.Principal,
  'calculator' : IDL.Principal,
});
export const MarketInit = IDL.Record({
  'x0' : IDL.Nat,
  'creator' : IDL.Principal,
  'base' : BaseToken,
  'meta' : TokenMeta,
  'icpswap' : IcpSwapIds,
  'ledger' : IDL.Principal,
  'factory' : IDL.Principal,
  'dev_buy' : IDL.Opt(IDL.Nat),
  'status_proxy' : IDL.Opt(IDL.Principal),
  'treasury' : IDL.Principal,
});
export const Account = IDL.Record({
  'owner' : IDL.Principal,
  'subaccount' : IDL.Opt(IDL.Vec(IDL.Nat8)),
});
export const BuyArgs = IDL.Record({
  'referrer' : IDL.Opt(IDL.Principal),
  'recipient' : IDL.Opt(Account),
  'from_subaccount' : IDL.Opt(IDL.Vec(IDL.Nat8)),
  'amount' : IDL.Nat,
  'min_tokens_out' : IDL.Nat,
});
export const Fill = IDL.Record({
  'out' : IDL.Nat,
  'base_net' : IDL.Nat,
  'completes' : IDL.Bool,
  'fee_platform' : IDL.Nat,
  'fee_creator' : IDL.Nat,
  'refund' : IDL.Nat,
});
export const PayoutStatus = IDL.Variant({
  'Queued' : IDL.Record({ 'id' : IDL.Nat64 }),
  'Sent' : IDL.Record({ 'block' : IDL.Nat }),
});
export const TradeOk = IDL.Record({
  'fill' : Fill,
  'payout' : PayoutStatus,
  'refund' : IDL.Opt(PayoutStatus),
});
export const CurveError = IDL.Variant({
  'TooSmall' : IDL.Null,
  'ZeroAmount' : IDL.Null,
  'ExceedsSold' : IDL.Record({ 'sold' : IDL.Nat }),
  'Slippage' : IDL.Record({ 'out' : IDL.Nat, 'min_out' : IDL.Nat }),
  'CurveComplete' : IDL.Null,
});
export const TradeError = IDL.Variant({
  'Refunded' : IDL.Record({
    'reason' : CurveError,
    'refund' : IDL.Opt(PayoutStatus),
  }),
  'Rejected' : IDL.Text,
  'Transfer' : IDL.Text,
  'Curve' : CurveError,
});
export const Result = IDL.Variant({ 'Ok' : TradeOk, 'Err' : TradeError });
export const Candle = IDL.Record({
  't' : IDL.Nat64,
  'low' : IDL.Float64,
  'high' : IDL.Float64,
  'close' : IDL.Float64,
  'open' : IDL.Float64,
  'volume' : IDL.Nat,
});
export const Challenge = IDL.Record({
  'height' : IDL.Nat64,
  'reward' : IDL.Nat,
  'open' : IDL.Bool,
  'prev_hash' : IDL.Vec(IDL.Nat8),
  'target' : IDL.Nat,
  'market' : IDL.Principal,
});
export const Result_1 = IDL.Variant({ 'Ok' : Challenge, 'Err' : IDL.Text });
export const Result_2 = IDL.Variant({ 'Ok' : PayoutStatus, 'Err' : IDL.Text });
export const Comment = IDL.Record({
  'at' : IDL.Nat64,
  'id' : IDL.Nat64,
  'who' : IDL.Principal,
  'text' : IDL.Text,
});
export const GraduationTicket = IDL.Record({
  'token_amount' : IDL.Nat,
  'base' : BaseToken,
  'ledger' : IDL.Principal,
  'base_amount' : IDL.Nat,
});
export const HttpRequest = IDL.Record({
  'url' : IDL.Text,
  'method' : IDL.Text,
  'body' : IDL.Vec(IDL.Nat8),
  'headers' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
});
export const HttpResponse = IDL.Record({
  'body' : IDL.Vec(IDL.Nat8),
  'headers' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
  'status_code' : IDL.Nat16,
});
export const GradStep = IDL.Variant({
  'Release' : IDL.Record({
    'pool' : IDL.Principal,
    'positions' : IDL.Vec(IDL.Nat),
  }),
  'Mint' : IDL.Record({ 'pool' : IDL.Principal }),
  'Deposit' : IDL.Record({ 'pool' : IDL.Principal }),
  'MintLp' : IDL.Record({ 'pool' : IDL.Principal }),
  'RequestPool' : IDL.Null,
});
export const Phase = IDL.Variant({
  'Graduating' : IDL.Record({
    'last_error' : IDL.Opt(IDL.Text),
    'step' : GradStep,
  }),
  'Graduated' : IDL.Record({
    'pool' : IDL.Principal,
    'positions' : IDL.Vec(IDL.Nat),
  }),
  'Trading' : IDL.Null,
});
export const MarketInfo = IDL.Record({
  'x' : IDL.Nat,
  'y' : IDL.Nat,
  'id' : IDL.Principal,
  'x0' : IDL.Nat,
  'height' : IDL.Nat64,
  'mine_supply' : IDL.Nat,
  'mined' : IDL.Nat,
  'cycles_balance' : IDL.Nat,
  'reward' : IDL.Nat,
  'outbox' : IDL.Nat64,
  'creator' : IDL.Principal,
  'creator_owed' : IDL.Nat,
  'platform_owed' : IDL.Nat,
  'lp_fees_token' : IDL.Nat,
  'expected_hashes' : IDL.Float64,
  'base' : BaseToken,
  'trades' : IDL.Nat64,
  'meta' : TokenMeta,
  'sold' : IDL.Nat,
  'created_at' : IDL.Nat64,
  'lp_fees_base' : IDL.Nat,
  'target' : IDL.Nat,
  'traders' : IDL.Nat64,
  'cycles_burned_rigs' : IDL.Nat,
  'referral_owed' : IDL.Opt(IDL.Nat),
  'cycles_burned_market' : IDL.Nat,
  'ledger' : IDL.Principal,
  'fees_referrers' : IDL.Opt(IDL.Nat),
  'raised' : IDL.Nat,
  'progress_bps' : IDL.Nat32,
  'gross_to_complete' : IDL.Nat,
  'token_fee' : IDL.Nat,
  'last_block_at' : IDL.Nat64,
  'phase' : Phase,
  'active_rigs' : IDL.Nat32,
  'price' : IDL.Float64,
  'curve_supply' : IDL.Nat,
  'volume_base' : IDL.Nat,
  'treasury' : IDL.Principal,
});
export const MinerStat = IDL.Record({
  'active' : IDL.Opt(IDL.Nat32),
  'owner' : IDL.Principal,
  'rigs' : IDL.Nat32,
  'locked' : IDL.Nat,
  'burned' : IDL.Nat,
});
export const Result_3 = IDL.Variant({ 'Ok' : IDL.Nat64, 'Err' : IDL.Text });
export const Result_4 = IDL.Variant({ 'Ok' : Fill, 'Err' : CurveError });
export const Referral = IDL.Record({ 'owed' : IDL.Nat, 'earned' : IDL.Nat });
export const SellArgs = IDL.Record({
  'referrer' : IDL.Opt(IDL.Principal),
  'recipient' : IDL.Opt(Account),
  'from_subaccount' : IDL.Opt(IDL.Vec(IDL.Nat8)),
  'min_base_out' : IDL.Nat,
  'amount' : IDL.Nat,
});
export const SubmitResult = IDL.Variant({
  'Won' : IDL.Record({ 'height' : IDL.Nat64, 'reward' : IDL.Nat }),
  'NotARig' : IDL.Null,
  'Invalid' : IDL.Null,
  'Stale' : IDL.Record({ 'height' : IDL.Nat64 }),
  'Closed' : IDL.Null,
});
export const Trade = IDL.Record({
  'at' : IDL.Nat64,
  'id' : IDL.Nat64,
  'buy' : IDL.Bool,
  'who' : IDL.Principal,
  'base' : IDL.Nat,
  'tokens' : IDL.Nat,
  'price' : IDL.Float64,
});

export const idlService: IDL.ServiceClass = IDL.Service({
  'buy' : IDL.Func([BuyArgs], [Result], []),
  'candles' : IDL.Func([IDL.Bool, IDL.Nat64], [IDL.Vec(Candle)], ['query']),
  'challenge' : IDL.Func([IDL.Nat], [Result_1], []),
  'claim_creator_fees' : IDL.Func([], [Result_2], []),
  'claim_platform_fees' : IDL.Func([], [Result_2], []),
  'claim_referral_fees' : IDL.Func([IDL.Principal], [Result_2], []),
  'comments' : IDL.Func([IDL.Nat32], [IDL.Vec(Comment)], ['query']),
  'graduation_ticket' : IDL.Func([], [IDL.Opt(GraduationTicket)], ['query']),
  'http_request' : IDL.Func([HttpRequest], [HttpResponse], ['query']),
  'info' : IDL.Func([], [MarketInfo], ['query']),
  'locked_of' : IDL.Func([IDL.Principal], [IDL.Nat], ['query']),
  'miners' : IDL.Func([], [IDL.Vec(MinerStat)], ['query']),
  'mining_info' : IDL.Func([], [Challenge], ['query']),
  'post_comment' : IDL.Func([IDL.Text], [Result_3], []),
  'quote_buy' : IDL.Func([IDL.Nat], [Result_4], ['query']),
  'quote_sell' : IDL.Func([IDL.Nat], [Result_4], ['query']),
  'referral_of' : IDL.Func([IDL.Principal], [Referral], ['query']),
  'sell' : IDL.Func([SellArgs], [Result], []),
  'submit' : IDL.Func([IDL.Nat64], [SubmitResult], []),
  'trades' : IDL.Func([IDL.Nat32], [IDL.Vec(Trade)], ['query']),
});

export const idlInitArgs: IDL.Type[] = [MarketInit];

export const idlFactory: IDL.InterfaceFactory = ({ IDL }) => {
  const BaseToken = IDL.Record({
    'fee' : IDL.Nat,
    'decimals' : IDL.Nat8,
    'icpswap_standard' : IDL.Text,
    'ledger' : IDL.Principal,
    'symbol' : IDL.Text,
  });
  const TokenMeta = IDL.Record({
    'x' : IDL.Opt(IDL.Text),
    'logo' : IDL.Text,
    'name' : IDL.Text,
    'description' : IDL.Text,
    'website' : IDL.Opt(IDL.Text),
    'telegram' : IDL.Opt(IDL.Text),
    'symbol' : IDL.Text,
  });
  const IcpSwapIds = IDL.Record({
    'passcode_manager' : IDL.Principal,
    'factory' : IDL.Principal,
    'calculator' : IDL.Principal,
  });
  const MarketInit = IDL.Record({
    'x0' : IDL.Nat,
    'creator' : IDL.Principal,
    'base' : BaseToken,
    'meta' : TokenMeta,
    'icpswap' : IcpSwapIds,
    'ledger' : IDL.Principal,
    'factory' : IDL.Principal,
    'dev_buy' : IDL.Opt(IDL.Nat),
    'status_proxy' : IDL.Opt(IDL.Principal),
    'treasury' : IDL.Principal,
  });
  const Account = IDL.Record({
    'owner' : IDL.Principal,
    'subaccount' : IDL.Opt(IDL.Vec(IDL.Nat8)),
  });
  const BuyArgs = IDL.Record({
    'referrer' : IDL.Opt(IDL.Principal),
    'recipient' : IDL.Opt(Account),
    'from_subaccount' : IDL.Opt(IDL.Vec(IDL.Nat8)),
    'amount' : IDL.Nat,
    'min_tokens_out' : IDL.Nat,
  });
  const Fill = IDL.Record({
    'out' : IDL.Nat,
    'base_net' : IDL.Nat,
    'completes' : IDL.Bool,
    'fee_platform' : IDL.Nat,
    'fee_creator' : IDL.Nat,
    'refund' : IDL.Nat,
  });
  const PayoutStatus = IDL.Variant({
    'Queued' : IDL.Record({ 'id' : IDL.Nat64 }),
    'Sent' : IDL.Record({ 'block' : IDL.Nat }),
  });
  const TradeOk = IDL.Record({
    'fill' : Fill,
    'payout' : PayoutStatus,
    'refund' : IDL.Opt(PayoutStatus),
  });
  const CurveError = IDL.Variant({
    'TooSmall' : IDL.Null,
    'ZeroAmount' : IDL.Null,
    'ExceedsSold' : IDL.Record({ 'sold' : IDL.Nat }),
    'Slippage' : IDL.Record({ 'out' : IDL.Nat, 'min_out' : IDL.Nat }),
    'CurveComplete' : IDL.Null,
  });
  const TradeError = IDL.Variant({
    'Refunded' : IDL.Record({
      'reason' : CurveError,
      'refund' : IDL.Opt(PayoutStatus),
    }),
    'Rejected' : IDL.Text,
    'Transfer' : IDL.Text,
    'Curve' : CurveError,
  });
  const Result = IDL.Variant({ 'Ok' : TradeOk, 'Err' : TradeError });
  const Candle = IDL.Record({
    't' : IDL.Nat64,
    'low' : IDL.Float64,
    'high' : IDL.Float64,
    'close' : IDL.Float64,
    'open' : IDL.Float64,
    'volume' : IDL.Nat,
  });
  const Challenge = IDL.Record({
    'height' : IDL.Nat64,
    'reward' : IDL.Nat,
    'open' : IDL.Bool,
    'prev_hash' : IDL.Vec(IDL.Nat8),
    'target' : IDL.Nat,
    'market' : IDL.Principal,
  });
  const Result_1 = IDL.Variant({ 'Ok' : Challenge, 'Err' : IDL.Text });
  const Result_2 = IDL.Variant({ 'Ok' : PayoutStatus, 'Err' : IDL.Text });
  const Comment = IDL.Record({
    'at' : IDL.Nat64,
    'id' : IDL.Nat64,
    'who' : IDL.Principal,
    'text' : IDL.Text,
  });
  const GraduationTicket = IDL.Record({
    'token_amount' : IDL.Nat,
    'base' : BaseToken,
    'ledger' : IDL.Principal,
    'base_amount' : IDL.Nat,
  });
  const HttpRequest = IDL.Record({
    'url' : IDL.Text,
    'method' : IDL.Text,
    'body' : IDL.Vec(IDL.Nat8),
    'headers' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
  });
  const HttpResponse = IDL.Record({
    'body' : IDL.Vec(IDL.Nat8),
    'headers' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
    'status_code' : IDL.Nat16,
  });
  const GradStep = IDL.Variant({
    'Release' : IDL.Record({
      'pool' : IDL.Principal,
      'positions' : IDL.Vec(IDL.Nat),
    }),
    'Mint' : IDL.Record({ 'pool' : IDL.Principal }),
    'Deposit' : IDL.Record({ 'pool' : IDL.Principal }),
    'MintLp' : IDL.Record({ 'pool' : IDL.Principal }),
    'RequestPool' : IDL.Null,
  });
  const Phase = IDL.Variant({
    'Graduating' : IDL.Record({
      'last_error' : IDL.Opt(IDL.Text),
      'step' : GradStep,
    }),
    'Graduated' : IDL.Record({
      'pool' : IDL.Principal,
      'positions' : IDL.Vec(IDL.Nat),
    }),
    'Trading' : IDL.Null,
  });
  const MarketInfo = IDL.Record({
    'x' : IDL.Nat,
    'y' : IDL.Nat,
    'id' : IDL.Principal,
    'x0' : IDL.Nat,
    'height' : IDL.Nat64,
    'mine_supply' : IDL.Nat,
    'mined' : IDL.Nat,
    'cycles_balance' : IDL.Nat,
    'reward' : IDL.Nat,
    'outbox' : IDL.Nat64,
    'creator' : IDL.Principal,
    'creator_owed' : IDL.Nat,
    'platform_owed' : IDL.Nat,
    'lp_fees_token' : IDL.Nat,
    'expected_hashes' : IDL.Float64,
    'base' : BaseToken,
    'trades' : IDL.Nat64,
    'meta' : TokenMeta,
    'sold' : IDL.Nat,
    'created_at' : IDL.Nat64,
    'lp_fees_base' : IDL.Nat,
    'target' : IDL.Nat,
    'traders' : IDL.Nat64,
    'cycles_burned_rigs' : IDL.Nat,
    'referral_owed' : IDL.Opt(IDL.Nat),
    'cycles_burned_market' : IDL.Nat,
    'ledger' : IDL.Principal,
    'fees_referrers' : IDL.Opt(IDL.Nat),
    'raised' : IDL.Nat,
    'progress_bps' : IDL.Nat32,
    'gross_to_complete' : IDL.Nat,
    'token_fee' : IDL.Nat,
    'last_block_at' : IDL.Nat64,
    'phase' : Phase,
    'active_rigs' : IDL.Nat32,
    'price' : IDL.Float64,
    'curve_supply' : IDL.Nat,
    'volume_base' : IDL.Nat,
    'treasury' : IDL.Principal,
  });
  const MinerStat = IDL.Record({
    'active' : IDL.Opt(IDL.Nat32),
    'owner' : IDL.Principal,
    'rigs' : IDL.Nat32,
    'locked' : IDL.Nat,
    'burned' : IDL.Nat,
  });
  const Result_3 = IDL.Variant({ 'Ok' : IDL.Nat64, 'Err' : IDL.Text });
  const Result_4 = IDL.Variant({ 'Ok' : Fill, 'Err' : CurveError });
  const Referral = IDL.Record({ 'owed' : IDL.Nat, 'earned' : IDL.Nat });
  const SellArgs = IDL.Record({
    'referrer' : IDL.Opt(IDL.Principal),
    'recipient' : IDL.Opt(Account),
    'from_subaccount' : IDL.Opt(IDL.Vec(IDL.Nat8)),
    'min_base_out' : IDL.Nat,
    'amount' : IDL.Nat,
  });
  const SubmitResult = IDL.Variant({
    'Won' : IDL.Record({ 'height' : IDL.Nat64, 'reward' : IDL.Nat }),
    'NotARig' : IDL.Null,
    'Invalid' : IDL.Null,
    'Stale' : IDL.Record({ 'height' : IDL.Nat64 }),
    'Closed' : IDL.Null,
  });
  const Trade = IDL.Record({
    'at' : IDL.Nat64,
    'id' : IDL.Nat64,
    'buy' : IDL.Bool,
    'who' : IDL.Principal,
    'base' : IDL.Nat,
    'tokens' : IDL.Nat,
    'price' : IDL.Float64,
  });

  return IDL.Service({
    'buy' : IDL.Func([BuyArgs], [Result], []),
    'candles' : IDL.Func([IDL.Bool, IDL.Nat64], [IDL.Vec(Candle)], ['query']),
    'challenge' : IDL.Func([IDL.Nat], [Result_1], []),
    'claim_creator_fees' : IDL.Func([], [Result_2], []),
    'claim_platform_fees' : IDL.Func([], [Result_2], []),
    'claim_referral_fees' : IDL.Func([IDL.Principal], [Result_2], []),
    'comments' : IDL.Func([IDL.Nat32], [IDL.Vec(Comment)], ['query']),
    'graduation_ticket' : IDL.Func([], [IDL.Opt(GraduationTicket)], ['query']),
    'http_request' : IDL.Func([HttpRequest], [HttpResponse], ['query']),
    'info' : IDL.Func([], [MarketInfo], ['query']),
    'locked_of' : IDL.Func([IDL.Principal], [IDL.Nat], ['query']),
    'miners' : IDL.Func([], [IDL.Vec(MinerStat)], ['query']),
    'mining_info' : IDL.Func([], [Challenge], ['query']),
    'post_comment' : IDL.Func([IDL.Text], [Result_3], []),
    'quote_buy' : IDL.Func([IDL.Nat], [Result_4], ['query']),
    'quote_sell' : IDL.Func([IDL.Nat], [Result_4], ['query']),
    'referral_of' : IDL.Func([IDL.Principal], [Referral], ['query']),
    'sell' : IDL.Func([SellArgs], [Result], []),
    'submit' : IDL.Func([IDL.Nat64], [SubmitResult], []),
    'trades' : IDL.Func([IDL.Nat32], [IDL.Vec(Trade)], ['query']),
  });
};

export const init: (args: { IDL: typeof IDL }) => IDL.Type[] = ({ IDL }) => {
  const BaseToken = IDL.Record({
    'fee' : IDL.Nat,
    'decimals' : IDL.Nat8,
    'icpswap_standard' : IDL.Text,
    'ledger' : IDL.Principal,
    'symbol' : IDL.Text,
  });
  const TokenMeta = IDL.Record({
    'x' : IDL.Opt(IDL.Text),
    'logo' : IDL.Text,
    'name' : IDL.Text,
    'description' : IDL.Text,
    'website' : IDL.Opt(IDL.Text),
    'telegram' : IDL.Opt(IDL.Text),
    'symbol' : IDL.Text,
  });
  const IcpSwapIds = IDL.Record({
    'passcode_manager' : IDL.Principal,
    'factory' : IDL.Principal,
    'calculator' : IDL.Principal,
  });
  const MarketInit = IDL.Record({
    'x0' : IDL.Nat,
    'creator' : IDL.Principal,
    'base' : BaseToken,
    'meta' : TokenMeta,
    'icpswap' : IcpSwapIds,
    'ledger' : IDL.Principal,
    'factory' : IDL.Principal,
    'dev_buy' : IDL.Opt(IDL.Nat),
    'status_proxy' : IDL.Opt(IDL.Principal),
    'treasury' : IDL.Principal,
  });

  return [MarketInit];
};
